import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'sd-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['../../assets/css/label.scss'],
})
export class CheckboxControlComponent {

  @Input() label: string;
  @Input() color: 'primary' | 'warn' = 'primary';
  @Input() disabled: boolean;
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter<any>();
  @Output() sdChange = new EventEmitter<any>();
  constructor(
    private ref: ChangeDetectorRef) {
  }

  // tslint:disable-next-line: variable-name
  _model: any;
  @Input() set model(value: boolean) {
    this.ref.detectChanges();
    this._model = value;
  }
  @Output() modelChange = new EventEmitter();

  onChange() {
    this.modelChange.emit(this._model);
    this.change.emit(this._model);
    this.sdChange.emit(this._model);
  }
}
